import { render, staticRenderFns } from "./GarageCarScreen.vue?vue&type=template&id=8b6373b4"
import script from "./GarageCarScreen.vue?vue&type=script&lang=js"
export * from "./GarageCarScreen.vue?vue&type=script&lang=js"
import style0 from "./GarageCarScreen.vue?vue&type=style&index=0&id=8b6373b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports